module.exports = __webpack_public_path__ + "img/frasagal04.7953b9c9.png";